import {useCompanyUser} from '@product-web/shell/user'
import {createPersistedState} from '@product-web/web-platform/persisted-state'

export function useCompanyLocalStorage(storageKeyPrefix: string) {
    const {companyId} = useCompanyUser()
    const STORAGE_KEY = `${storageKeyPrefix}-${companyId}`
    const [useLocalStorage] = createPersistedState(STORAGE_KEY, localStorage)
    return useLocalStorage
}
